"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageContentFragment = void 0;
const image_1 = require("./image");
exports.imageContentFragment = `
  fragment imageContent on ImageContent {
    images {
      ...image
    }
  }
  ${image_1.imageFragment}
`;
//# sourceMappingURL=image-content.js.map